/*
 * Permissive email format check for early client-side feedback. The back-end performs the
 * authoritative validation (canonicalization).
 */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function isValidEmail(email : string | undefined) : boolean {
    return email !== null && email !== undefined && EMAIL_PATTERN.test(email);
}

export const EmailUtils = () => {
    return
}

EmailUtils.isValidEmail = isValidEmail;
